import { useCustomTranslation } from '@amzn/work-spaces-web-client-core-lib';
import styles from './styles.module.scss';
import CentralizedLayout from '@/layout/CentralizedLayout';
import { useTheme } from '@/stores/theme';
import { Button } from '@cloudscape-design/components';
import * as React from 'react';
import BlockPlatformModal from '@components/BlockPlatformModal';

interface PlayVideoOverlayProps {
  playVideo: () => void;
}

const PlayVideoOverlay: React.FC<PlayVideoOverlayProps> = ({ playVideo }) => {
  const { t } = useCustomTranslation();
  const logo = useTheme((state) => state.logo);
  const fontColor = useTheme((state) => state.fontColor);

  return (
    <CentralizedLayout>
      <div
        id="overlay-play"
        className={styles['overlay-play']}
        style={{
          color: fontColor,
        }}
      >
        <img
          className={styles['logo-play']}
          src={logo}
          crossOrigin="anonymous"
          alt={t('ws-logo-alt')}
        />
        <p>{t('ws-play-description')}</p>
        <Button variant="primary" onClick={playVideo}>
          {t('ws-play-link')}
        </Button>
      </div>
      <BlockPlatformModal
        header={t('ws-pcoip-access-warning-header')}
        alertTitle={t('ws-pcoip-access-warning-title')}
        alertDescription={t('ws-pcoip-access-warning-description')}
        onClose={() => {}}
        isIncludeContinue={true}
      />
    </CentralizedLayout>
  );
};

export default PlayVideoOverlay;
